import { ColumnSort, SortingState } from '@tanstack/react-table';

/**
 * Converts a search parameter string to a React Table sorting state.
 * For example, the string `"name,-serial"` is converted to:
 * `[ { id: "name", desc: false }, { id: "serial", desc: true } ]`.
 *
 * @param {string} params - A comma-separated string of sort keys. A leading '-' indicates descending order.
 * @returns {ColumnSort[]} An array of React Table ColumnSort objects.
 */
export function searchParamToTableSortingState(
  params?: string | null,
): ColumnSort[] {
  if (params === null || params === undefined || params === '') {
    return [];
  }
  return params.split(',').map((sortField) => {
    if (sortField.startsWith('-')) {
      const fieldName = sortField.replace(/^-/, '');
      return {
        id: fieldName,
        desc: true,
      };
    } else {
      return {
        id: sortField,
        desc: false,
      };
    }
  });
}

/**
 * Converts a React Table sorting state to a search parameter string.
 * For example, the state `[ { id: "name", desc: false }, { id: "serial", desc: true } ]` is converted to:
 * `"name,-serial"`
 *
 * @param {ColumnSort[]} sortingState - An array of React Table ColumnSort objects.
 * @return {string} A comma-separated string of sort keys. A leading '-' indicates descending order.
 */
export function tableSortingStateToSearchParam(
  sortingState: SortingState,
): string {
  return sortingState
    .map((sort) => {
      return `${sort.desc ? '-' : ''}${sort.id}`;
    })
    .join(',');
}

export function hasNonEmptyField(filters?: Record<string, unknown>): boolean {
  return Object.values(filters ?? {}).some((value) => {
    if (typeof value === 'string') return value !== '';
    if (Array.isArray(value)) return value.length > 0;
    return false;
  });
}
